
import React from 'react';
import {defaultRenderer, Renderer} from 'components/Assistant/ChatArea/renderer';
import ChatResponse from 'components/Assistant/ChatResponse';
import {parsedANL} from 'components/Assistant/hooks/parser';

export const InitMessage = '[START CONVERSATION]';

export const renderer: Renderer = (props) => {
	const {message, send} = props;
	if (message.source === 'USER' &&
		message.message === InitMessage) {
		return null;
	} else if (!send || message.source !== 'ASSISTANT') {
		return defaultRenderer(props);
	}

	// Render assistant messages specially
	const parsed = parsedANL(message, props.isLast);
	return (
		<ChatResponse.ANL
			key={`${props.message.id}:${props.index}`}
			{...props}
			parsed={parsed}
			scroller={props.isLast && props.index > 1}
			send={send}
		/>
	);
};
